import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const TrainingFilters = ({
  audienceFilter,
  educationFilter,
  learningFormatFilter,
  professionalGroupFilter,
  providerFilter,
  startDateFilter,
  endDateFilter,
  searchQuery,
  setAudienceFilter,
  setEducationFilter,
  setLearningFormatFilter,
  setProfessionalGroupFilter,
  setProviderFilter,
  setStartDateFilter,
  setEndDateFilter,
  setSearchQuery,
  setResultSort,
  obj,
  results,
}) => {
  const [audiences, useAudiences] = useState([]);
  const [educationType, useEducationType] = useState([]);
  const [professionalGroup, useProfessionalGroup] = useState([]);

  useEffect(() => {
    setState(useAudiences, 'course_audience');
    setState(useEducationType, 'course_education_type');
    setState(useProfessionalGroup, 'course_professional_group');
  }, []);

  const setState = (stateSetter, property) => {
    results.forEach((r) => {
      stateSetter((prevValues) => {
        const allValues = [...prevValues, ...(r[property] || [])];
        return [...new Set(allValues)].sort();
      });
    });
  };

  const generateOptions = (labelKey, array, property) => {
    const label = I18n.t(labelKey);

    const sortedArray = [...array].sort((a, b) => {
      const aValue = property ? a[property] : a;
      const bValue = property ? b[property] : b;
      return aValue.localeCompare(bValue);
    });

    return [
      { label: label, value: '' },
      ...sortedArray.map((item) => ({
        label: property ? item[property] : item,
        value: property ? item[property] : item,
      })),
    ];
  };

  const audienceOptions = generateOptions(
    'training_overview_page.index.filter.target_group',
    audiences
  );
  const educationOptions = generateOptions(
    'training_overview_page.index.filter.qualification',
    educationType
  );
  const professionalGroupOptions = generateOptions(
    'training_overview_page.index.filter.course_professional_group',
    professionalGroup
  );
  const learningFormatOptions = generateOptions(
    'training_overview_page.index.filter.learning_format',
    obj.course_learning_format
  );
  const providerOptions = generateOptions(
    'training_overview_page.index.filter.course_provider_area',
    Array.from(
      new Set(
        results.map((provider) => provider.course_provider_area).filter(Boolean)
      )
    )
  );

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleResetFilters = () => {
    setAudienceFilter('');
    setEducationFilter('');
    setLearningFormatFilter('');
    setProfessionalGroupFilter('');
    setProviderFilter('');
    setStartDateFilter('');
    setEndDateFilter('');
    setSearchQuery('');
    setResultSort('');
  };

  const isActive = (filter) => filter.length > 0 && 'is-set';

  return (
    <div className="training-filter-widget">
      <div className="search-wrapper">
        <input
          type="text"
          placeholder={I18n.t('training_overview_page.index.filter.search_for')}
          value={searchQuery}
          onChange={handleSearchChange}
          aria-label={I18n.t(
            'training_overview_page.index.filter.enter_search_term'
          )}
        />
        <div className="icon">
          <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
        </div>
      </div>
      <div className="date-wrapper">
        <label>
          {I18n.t('events_overview_page.index.start_date')}
          <input
            type="date"
            value={startDateFilter}
            onChange={(e) => setStartDateFilter(e.target.value)}
            aria-label={I18n.t('training_overview_page.index.filter.date_from')}
          />
        </label>
        <label>
          {I18n.t('events_overview_page.index.end_date')}
          <input
            type="date"
            value={endDateFilter}
            onChange={(e) => setEndDateFilter(e.target.value)}
            aria-label={I18n.t('training_overview_page.index.filter.date_to')}
          />
        </label>
      </div>
      <div className="react-select-widget">
        <Select
          classNamePrefix="react-select"
          className={'react-select-container ' + isActive(providerFilter)}
          options={providerOptions}
          onChange={(selectedOption) =>
            setProviderFilter(selectedOption ? selectedOption.value : '')
          }
          value={providerOptions.find(
            (option) => option.value === providerFilter
          )}
          aria-label={I18n.t(
            'training_overview_page.index.filter.filter_by_course_provider_area'
          )}
        />
      </div>
      <div className="react-select-widget">
        <Select
          classNamePrefix="react-select"
          className={'react-select-container ' + isActive(educationFilter)}
          options={educationOptions}
          onChange={(selectedOption) =>
            setEducationFilter(selectedOption.value)
          }
          value={educationOptions.find(
            (option) => option.value === educationFilter
          )}
          aria-label={I18n.t(
            'training_overview_page.index.filter.filter_by_education_type'
          )}
        />
      </div>
      <div className="react-select-widget">
        <Select
          classNamePrefix="react-select"
          className={'react-select-container ' + isActive(audienceFilter)}
          options={audienceOptions}
          onChange={(selectedOption) => setAudienceFilter(selectedOption.value)}
          value={audienceOptions.find(
            (option) => option.value === audienceFilter
          )}
          aria-label={I18n.t(
            'training_overview_page.index.filter.filter_by_target_group'
          )}
        />
      </div>
      <div className="react-select-widget">
        <Select
          classNamePrefix="react-select"
          className={
            'react-select-container ' + isActive(professionalGroupFilter)
          }
          options={professionalGroupOptions}
          onChange={(selectedOption) =>
            setProfessionalGroupFilter(selectedOption.value)
          }
          value={professionalGroupOptions.find(
            (option) => option.value === professionalGroupFilter
          )}
          aria-label={I18n.t(
            'training_overview_page.index.filter.filter_by_professional_group'
          )}
        />
      </div>
      <div className="react-select-widget">
        <Select
          classNamePrefix="react-select"
          className={'react-select-container ' + isActive(learningFormatFilter)}
          options={learningFormatOptions}
          onChange={(selectedOption) =>
            setLearningFormatFilter(selectedOption.value)
          }
          value={learningFormatOptions.find(
            (option) => option.value === learningFormatFilter
          )}
          aria-label={I18n.t(
            'training_overview_page.index.filter.filter_by_learning_format'
          )}
        />
      </div>
      <div className="button-row">
        <button onClick={handleResetFilters}>
          <i className="fa-solid fa-xmark" aria-hidden="true"></i>
          {I18n.t('training_overview_page.index.filter.reset_filters')}
        </button>
      </div>
    </div>
  );
};

export default TrainingFilters;
